var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-top"},[_c('div',{staticClass:"title-holder"},[_c('a',{staticClass:"link-back",attrs:{"href":_vm.url}},[_c('i',{staticClass:"icon icon-arrow-back"})]),(_vm.title)?_c('h1',{staticClass:"title"},[_c('span',{staticClass:"title-item"},[_vm._v(_vm._s(_vm.title))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }